import React from 'react';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib';
import { useIsGuest } from '../guest';
import { guestTechDocsAddonsPlugin } from './guestTechDocsAddonsPlugin';

const GuestAwareReportIssueAddon = () => {
  const isGuest = useIsGuest();

  return isGuest ? null : <ReportIssue />;
};

export const GuestAwareReportIssue = guestTechDocsAddonsPlugin.provide(
  createTechDocsAddonExtension({
    name: 'GuestAwareReportIssue',
    location: TechDocsAddonLocations.Content,
    component: GuestAwareReportIssueAddon,
  }),
);
